import { render, staticRenderFns } from "./TicketHead.vue?vue&type=template&id=f7d01ccc&scoped=true&"
import script from "./TicketHead.vue?vue&type=script&lang=js&"
export * from "./TicketHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7d01ccc",
  null
  
)

export default component.exports